import { makeAutoObservable } from "mobx";
import queryString from "querystring";
import { NewsListRequestType } from "@/api/news/types";

export class NewsStore {
  selectedFilters: NewsListRequestType = {
    pageNumber: 1,
  };

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  setSelectedFilters = (filters: NewsListRequestType) => {
    this.selectedFilters = { ...this.selectedFilters, ...filters };

    const newUrlQuery = queryString.stringify({
      ...(this.selectedFilters.pageNumber !== undefined && { page_number: this.selectedFilters.pageNumber }),
    });

    const path = window.location.pathname;
    window.history.replaceState(null, "", `${path}?${newUrlQuery}`);
  };
}
